import { put, call, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { GoogleAdsType } from 'domain/types/googleAds.type';
import {
  fetchHourlyCoCSuccess, fetchHourlyCoCFailure,
  fetchHighestCostKwSuccess, fetchHighestCostKwFailure,
  fetchLowestConvKwSuccess, fetchLowestConvKwFailure,
  fetchCampaignsSuccess, fetchCampaignsFailure,
  fetchAdGroupsSuccess, fetchAdGroupsFailure,
  fetchSyncStatusSuccess, fetchSyncStatusFailure,
} from 'domain/actions/googleAds.action';
import { showLoading, hideLoading } from 'domain/actions/loading.action';
import {
  getHourlyCoC, getHighestCostKeywords, getLowestConvKeywords,
  getCampaigns, getAdGroups, getSyncStatus,
} from 'service/googleAds/googleAds.service';

function* fetchHourlyCoCSaga(action: any): SagaIterator {
  try {
    yield put(showLoading());
    const data = yield call(getHourlyCoC, action.payload.params);
    yield put(fetchHourlyCoCSuccess(data));
  } catch (error: any) {
    yield put(fetchHourlyCoCFailure(error?.message || 'Failed to fetch hourly CoC'));
  } finally {
    yield put(hideLoading());
  }
}

function* fetchHighestCostKwSaga(action: any): SagaIterator {
  try {
    yield put(showLoading());
    const data = yield call(getHighestCostKeywords, action.payload.params);
    yield put(fetchHighestCostKwSuccess(data));
  } catch (error: any) {
    yield put(fetchHighestCostKwFailure(error?.message || 'Failed to fetch highest cost keywords'));
  } finally {
    yield put(hideLoading());
  }
}

function* fetchLowestConvKwSaga(action: any): SagaIterator {
  try {
    yield put(showLoading());
    const data = yield call(getLowestConvKeywords, action.payload.params);
    yield put(fetchLowestConvKwSuccess(data));
  } catch (error: any) {
    yield put(fetchLowestConvKwFailure(error?.message || 'Failed to fetch lowest conversion keywords'));
  } finally {
    yield put(hideLoading());
  }
}

function* fetchCampaignsSaga(): SagaIterator {
  try {
    const campaigns = yield call(getCampaigns);
    yield put(fetchCampaignsSuccess(campaigns));
  } catch (error: any) {
    yield put(fetchCampaignsFailure(error?.message || 'Failed to fetch campaigns'));
  }
}

function* fetchAdGroupsSaga(action: any): SagaIterator {
  try {
    const adGroups = yield call(getAdGroups, action.payload.campaignId);
    yield put(fetchAdGroupsSuccess(adGroups));
  } catch (error: any) {
    yield put(fetchAdGroupsFailure(error?.message || 'Failed to fetch ad groups'));
  }
}

function* fetchSyncStatusSaga(): SagaIterator {
  try {
    const status = yield call(getSyncStatus);
    yield put(fetchSyncStatusSuccess(status));
  } catch (error: any) {
    yield put(fetchSyncStatusFailure(error?.message || 'Failed to fetch sync status'));
  }
}

export function* googleAdsSaga(): SagaIterator {
  yield takeLatest(GoogleAdsType.FETCH_HOURLY_COC_REQUEST, fetchHourlyCoCSaga);
  yield takeLatest(GoogleAdsType.FETCH_HIGHEST_COST_KW_REQUEST, fetchHighestCostKwSaga);
  yield takeLatest(GoogleAdsType.FETCH_LOWEST_CONV_KW_REQUEST, fetchLowestConvKwSaga);
  yield takeLatest(GoogleAdsType.FETCH_CAMPAIGNS_REQUEST, fetchCampaignsSaga);
  yield takeLatest(GoogleAdsType.FETCH_AD_GROUPS_REQUEST, fetchAdGroupsSaga);
  yield takeLatest(GoogleAdsType.FETCH_SYNC_STATUS_REQUEST, fetchSyncStatusSaga);
}
